
<span *ngIf="loading" class="row justify-content-center page-loading py-5"></span>

<div *ngIf="!loading" class="p-all">
  <div class="container-fluid border-container p-0" [ngClass]="selectedLine != '' ? 'bg-yellow-lines' : 'bg-white'">
    <header>
      <div class="header-left">
        <button class="info-icon" *ngIf="returnButton" (click)="showPlatform(undefined)"><</button>
        <img *ngIf="selectedLine == ''" alt="Logo CCTB" src="assets/img/logo_cctb2.svg" class="logo-cctb-header me-3">
        <i *ngIf="selectedLine != ''"  class="bi bi-arrow-left-circle-fill fs-3rem me-3" (click)="hideLine()"></i>
        <span *ngIf="platform != undefined && isValid && selectedLine == ''" class="stop-title">&nbsp;&nbsp;Cais {{ platform }}</span>
        <span *ngIf="selectedLine != ''" class="service-title">Serviços da linha {{ selectedLine }}</span>
      </div>
      <div class="header-right">
        <span class="clock">{{ hour }}</span>
      </div>
    </header>
    <div *ngIf="firstLines.length == 0 && isValid && !error">
      <div class="row justify-content-center">
        <div class="col-10 text-center align-middle py-5">
          <img src="assets/img/not_exist_service.png" alt="Serviço inexistente" class="img-out-service">
          <p *ngIf="platform" class="service-not-exist">Sem serviços para o cais {{ platform }}.</p>
          <p *ngIf="!platform" class="service-not-exist">Sem serviços.</p>
        </div>
      </div>
    </div>
    <div *ngIf="error || !isValid">
      <div class="row justify-content-center">
        <div class="col-10 text-center align-middle py-5">
          <img src="assets/img/out_service.png" alt="Fora de Serviço" class="img-out-service">
          <p class="service-error">Fora de serviço.</p>
        </div>
      </div>
    </div>
    <div *ngIf="!loading && !error && firstLines.length > 0 && isValid">
      <div class="first-line-service">
        <div class="next-service-list" [ngClass]="selectedLine != '' ? 'bg-next-service-line' : 'bg-next-service'">
          <div *ngIf="!error && isValid && firstLines.length > 0 || platform == undefined" class="next-service-label-container">
            <div class="next-service-label">
              Próximo serviço
            </div>
            <hr [ngClass]="selectedLine != '' ? 'line-black' : 'line'">
          </div>
          <div *ngFor="let line of firstLines" class="next-service-item">
            <div *ngIf="platform == undefined && selectedLine == ''" class="service-number">
              <span (click)="showPlatform(line.platform)">{{ line.platform }}</span>
            </div>
            <div class="service-details" (click)="showLine(line.line, line.operatorOriginal)">
              <span class="sub-details-operator">{{ line.operator }}</span>
              <span class="destination">{{ line.destination }}</span>
              <!--<marquee *ngIf="line.observation.length>20" class="sub-details">{{line.observation}}</marquee>-->
              <span class="sub-details">{{ line.observation }}</span>
            </div>
            <div class="d-flex flex-column" (click)="showLine(line.line, line.operatorOriginal)">
              <div class="service-time">{{ line.time }}</div>
              <div class="sub-details-cais text-center" *ngIf="selectedLine != ''">Cais {{ line.platform }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!loading && !error && listLinesToshow.length > 0 && isValid">
      <div *ngIf="listLinesToshow.length > 0" class="other-line-service">
        <ng-container>
          <div class="next-service-label-container mt-4">
            <div class="next-service-label">
              Serviços seguintes
              <span *ngIf="rotate=='true'"> ({{ lineList.length }})</span>
            </div>
            <hr [ngClass]="selectedLine != '' ? 'line-black' : 'line'">
          </div>
          <div *ngFor="let line of listLinesToshow" [ngClass]="selectedLine != '' ? 'service-item-lines' : 'service-item'">
            <div *ngIf="platform == undefined && selectedLine == ''" class="service-number">
              <span (click)="showPlatform(line.platform)">{{ line.platform }}</span>
            </div>
            <div class="service-details" (click)="showLine(line.line, line.operatorOriginal)">
              <span class="sub-details-operator">{{ line.operator }}</span>
              <span class="destination">{{ line.destination }}</span>
              <!--<marquee *ngIf="line.observation.length>20" class="sub-details">{{line.observation}}</marquee>-->
              <span class="sub-details">{{ line.observation }}</span>
            </div>
            <div class="d-flex flex-column" (click)="showLine(line.line, line.operatorOriginal)">
              <span class="service-time">{{ line.time }}</span>
              <span class="sub-details-cais text-center" *ngIf="selectedLine != ''">Cais {{ line.platform }}</span>
            </div>
          </div>
          <div class="circle" *ngIf="rotate=='true'">
            <button *ngFor="let n of numSequence(numberOfPages)" [ngClass]='listPage == n ? "circleForNON" : "circleForNOFF"' (click)="changeToPage(n)"></button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<footer>
  <div><img alt="Logo Wegoshare" src="../assets/img/logo_wgs_white.png" class="img-fluid logo-wgs"></div>
  <div><span *ngIf="!conection" class="bi bi-wifi-off fs-3rem me-3"></span><i class="bi bi-info-circle fs-3rem" data-bs-toggle="modal" data-bs-target="#myModal" (click)="showModal()"></i></div>
</footer>


<!-- The Modal -->
<div class="modal" id="myModal">
  <div class="modal-dialog modal-dialog-centered ">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-11 d-inline-flex">
              <img alt="Logo CCTB" src="assets/img/logo_cctb.png" class="img-fluid logo-cctb">
              <h4 class="modal-title ms-2">CCTB - Centro Coordenador de Transportes de Braga</h4>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="p-3">
          <h3 class="modal-title">Sistema de Informação ao público para pessoas com deficiência visual</h3>
        </div>
        <div class="p-3 fs-1-25rem">
          A acessibilidade em sistemas de transporte público é fundamental para garantir a
          inclusão social e a mobilidade autónoma de pessoas com deficiências visuais ou

          dificuldades de visão. Tecnologias assistivas, como displays de elevado contraste, e-
          paper, beacons sonoros e pontos de informação com TTS (text-to-speech),

          desempenham um papel essencial ao reduzir barreiras e tornar as informações
          acessíveis a todos os utilizadores, independentemente das suas capacidades.
        </div>
        <div class="modal-image mt-4">
          <div class="row"></div>
          <img alt="Logo Wegoshare" src="assets/img/logo_wgs_black.png" class="logo-wgs-footer img-fluid">
        </div>
        <div class="modal-image mt-4">
          <span class="footer-text">Wegoshare, Lda. &copy; {{ year }}</span>
        </div>
        <div class="modal-image mt-4">
          <span class="footer-text">versão {{ version }}</span>
        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer p-0">
        <button #closeModal type="button" class="btn btn-danger btn-80" data-bs-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
